import { useMutation, useQueryClient } from '@tanstack/react-query';
// DELETE requests must use `del` — `remove` silently no-ops inside mutationFn.
import { del } from '@truefit/http-utils';

import {
  TRANSCODING_PROFILES_QUERY_KEY,
  TRANSCODING_PROFILES_URL,
} from './useTranscodingProfilesQuery';

export const useDeleteTranscodingProfileMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (id: number): Promise<{ id: number }> => {
      await del(`${TRANSCODING_PROFILES_URL}/${id}`);
      return { id };
    },
    onSuccess: () =>
      queryClient.invalidateQueries({ queryKey: TRANSCODING_PROFILES_QUERY_KEY }),
  });
};

export default useDeleteTranscodingProfileMutation;
